import { Component, ChangeDetectionStrategy, inject } from '@angular/core';
import { DsDialogInstance } from '@skyeng/libs/shared/ui-kit-v2/dialog';

@Component({
  selector: 'skypro-message-attachment-fullsize-dialog',
  templateUrl: 'attachment-fullsize-dialog.html',
  styleUrls: ['attachment-fullsize-dialog.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class AttachmentFullsizeDialogComponent {
  private dsDialogInstance = inject(DsDialogInstance<void, { url: string; type: string }>);
  url = this.dsDialogInstance.data.url;
  type = this.dsDialogInstance.data.type;
}
